import * as actionTypes from './actionTypes';
import { axiosProtected } from '../../axios-wizard';
import { normalize } from 'normalizr';
import * as schema from '../schema';


export const fetchAccessTokens = () => {
    const url = '/api/access_tokens/';

    return dispatch => {
        dispatch( fetchAccessTokensStart() );
        return axiosProtected.get( url )
            .then( response => {
               dispatch(fetchAccessTokensSuccess());
               return response.data['access_tokens'];
            } )
            .catch( error => {
                dispatch(fetchAcessTokensFailed());
            } );
    };
};

export const fetchAccessTokensStart = (  ) => {
    return {
        type: actionTypes.FETCH_ACCESS_TOKENS_START
    };
};

export const fetchAccessTokensSuccess = ( users ) => {
    return {
        type: actionTypes.FETCH_ACCESS_TOKENS_SUCCESS
    };
};

export const fetchAcessTokensFailed = () => {
    return {
        type: actionTypes.FETCH_ACCESS_TOKENS_FAILED
    };
};



export const saveAccessToken = (params) => {
    const url = '/api/access_tokens/';
    return dispatch => {
        dispatch( saveAccessTokenStart() );
        return axiosProtected.post( url, {access_token: params})
            .then( response => {
               dispatch(saveAccessTokenSuccess());
               return response.data['access_tokens'];
            } )
            .catch( error => {
                dispatch(saveAccessTokenFailed());
            } );
    };
};


export const saveAccessTokenStart = (  ) => {
    return {
        type: actionTypes.SAVE_ACCESS_TOKEN_START
    };
};

const saveAccessTokenSuccess = ( projects ) => {
    return {
        type: actionTypes.SAVE_ACCESS_TOKEN_SUCCESS,
    };
};

const saveAccessTokenFailed = () => {
    return {
        type: actionTypes.SAVE_ACCESS_TOKEN_FAILED
    };
};


export const deleteAccessToken= (id) => {
    const url = '/api/access_tokens/' + id
    return dispatch => {
        dispatch( deleteAccessTokenStart() );
        return axiosProtected.delete( url )
            .then( response => {
               dispatch(deleteAccessTokenSuccess(id));
            } )
            .catch( error => {
                dispatch(deleteAccessTokenFailed());
            } );
    };
};



export const deleteAccessTokenStart = (  ) => {
    return {
        type: actionTypes.DELETE_ACCESS_TOKEN_START
    };
};

const deleteAccessTokenSuccess = ( id ) => {
    return {
        type: actionTypes.DELETE_ACCESS_TOKEN_SUCCESS,
    };
};

const deleteAccessTokenFailed = () => {
    return {
        type: actionTypes.DELETE_ACCESS_TOKEN_FAILED
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/access_tokens.js